// src/components/KanbanCard.js
import React, { useState, useEffect } from 'react';
import DetalhesModal from './DetalhesModal';
import AgendamentoModal from './AgendamentoModal';
import ReprovacaoModal from './ReprovacaoModal';
import FollowUpModal from './FollowUpModal';
import { agendamentosAPI } from '../services/api';
import axios from 'axios';

const API_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:3001/api' 
  : '/api';

function KanbanCard({ oportunidade, onDragStart, onRecarregar, onDeletar }) {
  const [modalAberto, setModalAberto] = useState(false);
  const [modalAgendamentoAberto, setModalAgendamentoAberto] = useState(false);
  const [modalReprovacaoAberto, setModalReprovacaoAberto] = useState(false);
  const [modalFollowUpAberto, setModalFollowUpAberto] = useState(false);
  const [agendamento, setAgendamento] = useState(null);
  
  // Estados para Proposta IA
  const [gerandoProposta, setGerandoProposta] = useState(false);
  const [propostaGerada, setPropostaGerada] = useState(oportunidade.proposta_ia_gerada || false);
  const [modalPropostaGerada, setModalPropostaGerada] = useState(false);
  const [propostaIAPath, setPropostaIAPath] = useState(oportunidade.proposta_ia_path || null);

  useEffect(() => {
    if (oportunidade.status === 'aguardando_atendimento') {
      carregarAgendamento();
    }
  }, [oportunidade.id, oportunidade.status]);

  const carregarAgendamento = async () => {
    try {
      const response = await agendamentosAPI.buscarPorOportunidade(oportunidade.id);
      if (response.data.data) {
        setAgendamento(response.data.data);
      }
    } catch (error) {
      console.error('Erro ao carregar agendamento:', error);
    }
  };

  // Função para gerar proposta com IA
  const handleGerarPropostaIA = async (e) => {
    e.stopPropagation();
    
    console.log('🤖 INICIANDO GERAÇÃO DE PROPOSTA...');
    
    try {
      setGerandoProposta(true);
      console.log('⏳ Estado: Gerando proposta...');
      
      const response = await axios.post(
        `${API_URL}/oportunidades/${oportunidade.id}/gerar-proposta-ia`
      );
      
      console.log('✅ RESPOSTA RECEBIDA:', response.data);
      
      if (response.data.success) {
        console.log('🎉 SUCESSO! Proposta gerada!');
        
        // ✅ SALVAR NO ESTADO LOCAL
        setPropostaGerada(true);
        setPropostaIAPath(response.data.pdf_path);
        
        console.log('📋 Estados atualizados:', {
          propostaGerada: true,
          propostaIAPath: response.data.pdf_path
        });
        
        setGerandoProposta(false);
        setModalPropostaGerada(true);
      }
    } catch (error) {
      console.error('❌ ERRO ao gerar proposta:', error);
      alert('❌ Erro ao gerar proposta:\n' + (error.response?.data?.error || error.message));
      setGerandoProposta(false);
    }
  };

  // Função para abrir agendamento após gerar proposta
  const handleAgendarAposGerar = () => {
    console.log('🎯 CLICOU EM SIM AGENDAR');
    
    setModalPropostaGerada(false);
    
    if (window.onAgendarEnvio) {
      console.log('✅ Chamando window.onAgendarEnvio com dados atualizados...');
      
      // PASSA UM NOVO OBJETO COM OS DADOS ATUALIZADOS
      window.onAgendarEnvio({
        ...oportunidade,
        proposta_ia_gerada: true,
        proposta_ia_path: propostaIAPath
      });
      
      console.log('📋 Dados passados:', {
        id: oportunidade.id,
        proposta_ia_gerada: true,
        proposta_ia_path: propostaIAPath
      });
    } else {
      console.error('❌ window.onAgendarEnvio não existe!');
    }
  };

  // Fechar modal sem agendar
  const handleDepoisAgendar = () => {
    console.log('⏭️ CLICOU EM DEPOIS');
    setModalPropostaGerada(false);
    if (onRecarregar) {
      onRecarregar();
    }
  };

  // Visualizar proposta
  const handleVisualizarProposta = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    console.log('👁️ CLICOU EM VISUALIZAR');
    console.log('📄 propostaIAPath:', propostaIAPath);
    
    const pdfPath = propostaIAPath || oportunidade.proposta_ia_path;
    
    if (!pdfPath) {
      console.error('❌ Caminho do PDF não encontrado!');
      alert('❌ Caminho do PDF não encontrado!\n\nGere a proposta novamente.');
      return;
    }
    
    // Extrai apenas o nome do arquivo do caminho completo
    const fileName = pdfPath.split('\\').pop().split('/').pop();
    console.log('📄 Nome do arquivo:', fileName);
    
    // Monta a URL
    const pdfUrl = `${window.location.origin}/outputs/propostas/${fileName}`;
    console.log('🔗 URL completa:', pdfUrl);
    
    // Abre em nova aba
    window.open(pdfUrl, '_blank');
  };

  const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valor || 0);
  };

  const formatarData = (data) => {
    if (!data) return '';
    const date = new Date(data);
    return date.toLocaleDateString('pt-BR');
  };

  const formatarDataHora = (data, hora) => {
    if (!data) return '';
    const dataFormatada = formatarData(data);
    const horaFormatada = hora ? hora.slice(0, 5) : '';
    return `${dataFormatada} às ${horaFormatada}`;
  };

  const getTipoServicoColor = (tipo) => {
    const cores = {
      'CFTV': 'blue',
      'Rede': 'purple',
      'Wi-Fi': 'green',
      'Interfone': 'purple',
      'Alarme': 'red',
      'Mix': 'orange'
    };
    return cores[tipo] || 'gray';
  };

  const handleDragStart = (e) => {
    onDragStart(e, oportunidade);
  };

  const handleDeletar = async (e) => {
    e.stopPropagation();
    if (window.confirm('Tem certeza que deseja deletar esta OS?')) {
      await onDeletar(oportunidade.id);
    }
  };

  const handleReprovar = async (e) => {
    e.stopPropagation();
    setModalReprovacaoAberto(true);
  };

  const handleConfirmarReprovacao = async (motivo) => {
    if (window.onReprovar) {
      await window.onReprovar(oportunidade.id, motivo);
    }
  };

  const handleFollowUp = async (e) => {
    e.stopPropagation();
    setModalFollowUpAberto(true);
  };

  const handleConfirmarFollowUp = async (observacao) => {
    if (window.onRegistrarFollowUp) {
      await window.onRegistrarFollowUp(oportunidade.id, observacao);
    }
  };

  const handleAbrirGestaoClick = (e) => {
    e.stopPropagation();
    if (oportunidade.os_id_gestao_click) {
      window.open(`https://gestaoclick.com/ordens_servicos/editar/${oportunidade.os_id_gestao_click}`, '_blank');
    }
  };

  const handleAbrirAgendamento = (e) => {
    e.stopPropagation();
    setModalAgendamentoAberto(true);
  };

  const handleSalvarAgendamento = async (dados) => {
    try {
      const dadosCompletos = {
        ...dados,
        oportunidade_id: oportunidade.id
      };

      console.log('🔍 DADOS COMPLETOS COM ID:', dadosCompletos);
      
      let resultado;
      const isEdicao = !!agendamento;
      const tecnicoAntigoId = agendamento?.tecnico_id;
      
      if (agendamento) {
        resultado = await agendamentosAPI.atualizar(agendamento.id, dadosCompletos);
      } else {
        resultado = await agendamentosAPI.criar(dadosCompletos);
      }
      
      if (isEdicao && resultado?.data?.trocouTecnico) {
        try {
          await fetch(`${API_URL}/tecnicos/notificar-transferencia`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              tecnico_antigo_id: tecnicoAntigoId,
              oportunidade_id: oportunidade.id
            })
          });
          
          const agendamentoAtualizado = resultado?.data?.data || resultado?.data;
          if (agendamentoAtualizado?.id) {
            await fetch(`${API_URL}/tecnicos/notificar-agendamento`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ agendamento_id: agendamentoAtualizado.id })
            });
          }
          
          alert('✅ Técnico alterado! Ambos foram notificados via WhatsApp.');
        } catch (error) {
          console.error('Erro ao notificar troca:', error);
        }
      } else if (isEdicao) {
        try {
          const agendamentoAtualizado = resultado?.data?.data || resultado?.data;
          if (agendamentoAtualizado?.id) {
            await fetch(`${API_URL}/tecnicos/notificar-alteracao`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ agendamento_id: agendamentoAtualizado.id })
            });
            alert('✅ Agendamento alterado e técnico notificado via WhatsApp!');
          }
        } catch (error) {
          console.error('Erro ao notificar alteração:', error);
        }
      }
      
      setModalAgendamentoAberto(false);
      await carregarAgendamento();
      
      if (onRecarregar) {
        onRecarregar();
      }
      
      return resultado?.data?.data || resultado?.data || resultado;
    } catch (error) {
      console.error('Erro ao salvar agendamento:', error);
      alert('Erro ao salvar agendamento!');
      throw error;
    }
  };

  const handleCancelarAgendamento = async (e) => {
    e.stopPropagation();
    
    if (window.confirm('Cancelar este agendamento?')) {
      try {
        console.log('🔍 CANCELANDO - Agendamento:', agendamento);
        console.log('🔍 Técnico ID:', agendamento.tecnico_id);
        
        await agendamentosAPI.cancelar(agendamento.id);
        
        console.log('✅ Agendamento cancelado no backend');
        
        if (agendamento.tecnico_id) {
          console.log('📱 Tentando notificar técnico...');
          try {
            const notifResponse = await fetch(`${API_URL}/tecnicos/notificar-cancelamento`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ agendamento_id: agendamento.id })
            });
            
            console.log('📱 Status resposta:', notifResponse.status);
            const data = await notifResponse.json();
            console.log('📱 Dados resposta:', data);
            
            if (data.success) {
              alert('✅ Agendamento cancelado e técnico notificado via WhatsApp!');
            } else {
              alert('✅ Agendamento cancelado! ⚠️ Erro ao notificar: ' + data.error);
            }
          } catch (error) {
            console.error('❌ Erro ao notificar cancelamento:', error);
            alert('✅ Agendamento cancelado! ⚠️ Não foi possível notificar o técnico.');
          }
        } else {
          console.warn('⚠️ Agendamento sem técnico atribuído');
          alert('✅ Agendamento cancelado!');
        }
        
        setAgendamento(null);
        
        if (onRecarregar) {
          onRecarregar();
        }
      } catch (error) {
        console.error('❌ Erro ao cancelar agendamento:', error);
        alert('Erro ao cancelar agendamento!');
      }
    }
  };

  // ✅ FUNÇÃO CORRIGIDA - USA OS_CODIGO DO BANCO!
  const getNumeroOS = () => {
    // ✅ PRIMEIRO: Tenta usar o campo dedicado os_codigo (vem do banco)
    if (oportunidade.os_codigo) {
      return oportunidade.os_codigo;
    }
    
    // ⚠️ FALLBACK: Se não tiver os_codigo, tenta extrair do título
    // Isso mantém compatibilidade com OS antigas que não têm o campo
    const match = oportunidade.titulo.match(/OS[#\s]*(\d+)/i);
    return match ? match[1] : '';
  };

  // ✨ EXTRAI NOME REAL DO CLIENTE DAS OBSERVAÇÕES
  const extrairNomeRealCliente = () => {
    if (!oportunidade.observacoes) return null;
    
    // Procura padrão: 👤 CLIENTE: Nome do Cliente
    const match = oportunidade.observacoes.match(/CLIENTE:\s*(.+?)(?:\n|$)/i);
    return match ? match[1].trim() : null;
  };

  return (
    <>
      <div
        className="kanban-card"
        draggable="true"
        onDragStart={handleDragStart}
        onClick={() => setModalAberto(true)}
      >
        <div className="kanban-card-header">
          <div className="header-row-inline">
            <div className="os-numero">OS #{getNumeroOS()}</div>
            <div className="os-data">📅 {formatarData(oportunidade.data_criacao)}</div>
            <div className="card-actions">
              {oportunidade.os_id_gestao_click && (
                <button
                  className="btn-icon btn-gestao"
                  onClick={handleAbrirGestaoClick}
                  title="Abrir no Gestão Click"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="11" cy="11" r="8"/>
                    <path d="m21 21-4.35-4.35"/>
                  </svg>
                </button>
              )}
              {oportunidade.status === 'solicitacao_orcamento' && (
                <button
                  className="btn-icon btn-agendar"
                  onClick={() => window.onAgendarEnvio && window.onAgendarEnvio(oportunidade)}
                  title="Agendar Envio de Orçamento"
                  style={{
                    background: '#2196f3',
                    color: 'white'
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12 6 12 12 16 14"/>
                  </svg>
                </button>
              )}
              {oportunidade.status === 'orcamento_enviado' && (
                <>
                  <button
                    className="btn-icon btn-followup"
                    onClick={handleFollowUp}
                    title={
                      oportunidade.followups_realizados >= 3 
                        ? 'Limite de 3 contatos atingido' 
                        : `Registrar Contato (${oportunidade.followups_realizados || 0}/3)`
                    }
                    disabled={oportunidade.followups_realizados >= 3}
                    style={{
                      opacity: oportunidade.followups_realizados >= 3 ? 0.4 : 1,
                      cursor: oportunidade.followups_realizados >= 3 ? 'not-allowed' : 'pointer'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                    </svg>
                  </button>
                  <button
                    className="btn-icon btn-reprovar"
                    onClick={handleReprovar}
                    title="Reprovar Orçamento"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M15 9l-6 6M9 9l6 6"/>
                    </svg>
                  </button>
                </>
              )}
              {oportunidade.status !== 'orcamento_enviado' && (
                <button
                  className="btn-icon btn-delete"
                  onClick={handleDeletar}
                  title="Deletar"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="3 6 5 6 21 6"/>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                    <line x1="10" y1="11" x2="10" y2="17"/>
                    <line x1="14" y1="11" x2="14" y2="17"/>
                  </svg>
                </button>
              )}
            </div>
          </div>
          
          <h4 className="kanban-card-title">
            {oportunidade.cliente_nome}
            {oportunidade.cliente_nome === 'NOVO CLIENTE' && (
              <span className="badge badge-red" style={{marginLeft: '8px', fontSize: '0.7em'}}>
                ⚠️ Cadastrar
              </span>
            )}
          </h4>
          
          {/* ✨ NOME REAL DO CLIENTE (EXTRAÍDO DAS OBSERVAÇÕES) */}
          {extrairNomeRealCliente() && (
            <div style={{
              fontSize: '12px',
              color: '#666',
              marginTop: '4px',
              marginBottom: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}>
              <span>👤</span>
              <span style={{ fontWeight: '500' }}>{extrairNomeRealCliente()}</span>
            </div>
          )}
          
          {oportunidade.tipo_servico && (
            <span className={`badge badge-${getTipoServicoColor(oportunidade.tipo_servico)}`}>
              {oportunidade.tipo_servico}
            </span>
          )}
          
          {oportunidade.status === 'orcamento_enviado' && (
            <span 
              className="badge" 
              style={{
                backgroundColor: oportunidade.followups_realizados >= 3 ? '#ff9800' : '#2196f3',
                color: 'white',
                marginLeft: '8px'
              }}
              title={`${oportunidade.followups_realizados || 0} contatos realizados`}
            >
              📞 {oportunidade.followups_realizados || 0}/3
            </span>
          )}
        </div>

        <div className="kanban-card-body">
          {/* BOTÃO GERAR PROPOSTA IA - SOLICITAÇÃO DE ORÇAMENTO */}
          {oportunidade.status === 'solicitacao_orcamento' && (
            <div className="proposta-ia-section" style={{ marginBottom: '12px' }}>
              <button
                onClick={handleGerarPropostaIA}
                disabled={gerandoProposta}
                className="btn-proposta-ia"
                style={{
                  width: '100%',
                  padding: '10px',
                  backgroundColor: propostaGerada ? '#10b981' : '#8b5cf6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: '600',
                  cursor: gerandoProposta ? 'not-allowed' : 'pointer',
                  opacity: gerandoProposta ? 0.6 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  transition: 'all 0.2s'
                }}
                title={propostaGerada ? 'Proposta já gerada - Clique para gerar novamente' : 'Gerar proposta profissional com IA'}
              >
                {gerandoProposta ? (
                  <>
                    <span style={{ animation: 'spin 1s linear infinite' }}>⏳</span>
                    <span>Gerando proposta...</span>
                  </>
                ) : propostaGerada ? (
                  <>
                    <span>✅</span>
                    <span>Regerar Proposta IA</span>
                  </>
                ) : (
                  <>
                    <span>✨</span>
                    <span>Gerar Proposta IA</span>
                  </>
                )}
              </button>
            </div>
          )}

          {oportunidade.status === 'aguardando_atendimento' && (
            <div className="agendamento-section">
              {agendamento ? (
                <>
                  <div className="agendamento-info-card">
                    <div className="agendamento-data">
                      📅 {formatarDataHora(agendamento.data_agendamento, agendamento.hora_agendamento)}
                    </div>
                    <div className="agendamento-tecnico">
                      👷 {agendamento.tecnico_nome}
                    </div>
                  </div>
                  <div className="agendamento-actions">
                    <button
                      className="btn-agendamento btn-editar"
                      onClick={handleAbrirAgendamento}
                      title="Editar Agendamento"
                    >
                      ✏️ Editar
                    </button>
                    <button
                      className="btn-agendamento btn-cancelar-agend"
                      onClick={handleCancelarAgendamento}
                      title="Cancelar Agendamento"
                    >
                      🗑️ Cancelar
                    </button>
                  </div>
                </>
              ) : (
                <button
                  className="btn-agendar"
                  onClick={handleAbrirAgendamento}
                  title="Agendar Atendimento"
                >
                  📅 Agendar Atendimento
                </button>
              )}
            </div>
          )}

          <div className="valores-section">
            {oportunidade.valor_servicos > 0 && (
              <div className="valor-row">
                <span className="valor-label">🔧 Serviços:</span>
                <span className="valor-value">{formatarValor(oportunidade.valor_servicos)}</span>
              </div>
            )}
            {oportunidade.valor_produtos > 0 && (
              <div className="valor-row">
                <span className="valor-label">📦 Produtos:</span>
                <span className="valor-value">{formatarValor(oportunidade.valor_produtos)}</span>
              </div>
            )}
            <div className="valor-row total">
              <span className="valor-label">💰 Total:</span>
              <span className="valor-value">{formatarValor(oportunidade.valor_real)}</span>
            </div>
          </div>

          {oportunidade.status === 'faturado' && (
            <div className="indicadores-faturado">
              <div className="indicador indicador-servicos">
                <div className="indicador-label">Serviços</div>
                <div className="indicador-valor">{formatarValor(oportunidade.valor_servicos)}</div>
              </div>
              <div className="indicador indicador-produtos">
                <div className="indicador-label">Produtos</div>
                <div className="indicador-valor">{formatarValor(oportunidade.valor_produtos)}</div>
              </div>
              {oportunidade.lucro_produtos > 0 && (
                <div className="indicador indicador-lucro">
                  <div className="indicador-label">Lucro Produtos</div>
                  <div className="indicador-valor">{formatarValor(oportunidade.lucro_produtos)}</div>
                </div>
              )}
              <div className="indicador indicador-lucro-total">
                <div className="indicador-label">💰 LUCRO TOTAL</div>
                <div className="indicador-valor">
                  {formatarValor(
                    (parseFloat(oportunidade.lucro_produtos) || 0) + 
                    (parseFloat(oportunidade.valor_servicos) || 0)
                  )}
                </div>
              </div>
            </div>
          )}

          {oportunidade.tecnico_nome && (
            <div className="kanban-card-info">
              👷 {oportunidade.tecnico_nome}
            </div>
          )}
        </div>
      </div>

      {modalAberto && (
        <DetalhesModal
          oportunidade={oportunidade}
          onClose={() => setModalAberto(false)}
          onRecarregar={onRecarregar}
        />
      )}

      {modalAgendamentoAberto && (
        <AgendamentoModal
          isOpen={modalAgendamentoAberto}
          onClose={() => setModalAgendamentoAberto(false)}
          oportunidade={oportunidade}
          agendamento={agendamento}
          onSalvar={handleSalvarAgendamento}
        />
      )}

      {modalReprovacaoAberto && (
        <ReprovacaoModal
          isOpen={modalReprovacaoAberto}
          onClose={() => setModalReprovacaoAberto(false)}
          oportunidade={oportunidade}
          onConfirmar={handleConfirmarReprovacao}
        />
      )}

      {modalFollowUpAberto && (
        <FollowUpModal
          isOpen={modalFollowUpAberto}
          onClose={() => setModalFollowUpAberto(false)}
          oportunidade={oportunidade}
          onConfirmar={handleConfirmarFollowUp}
        />
      )}

      {/* MODAL: PROPOSTA GERADA COM SUCESSO */}
      {modalPropostaGerada && (
        <div className="modal-overlay" onClick={handleDepoisAgendar}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h2>✅ Proposta IA Gerada!</h2>
              <button className="modal-close" onClick={handleDepoisAgendar}>&times;</button>
            </div>
            
            <div className="modal-body">
              <p style={{ fontSize: '15px', marginBottom: '20px', textAlign: 'center' }}>
                Proposta profissional criada com sucesso!<br/>
                PDF disponível para envio via WhatsApp.
              </p>
              
              <p style={{ fontSize: '16px', fontWeight: '600', marginBottom: '15px', textAlign: 'center' }}>
                Deseja agendar o envio agora?
              </p>
            </div>

            <div className="modal-footer" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {/* BOTÃO PREVIEW */}
              <button 
                type="button"
                onClick={handleVisualizarProposta}
                className="btn-secondary"
                style={{ 
                  width: '100%',
                  padding: '12px',
                  backgroundColor: '#6366f1',
                  color: 'white',
                  border: 'none',
                  fontWeight: '600',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                👁️ Visualizar Proposta
              </button>

              {/* BOTÕES DE AÇÃO */}
              <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                <button 
                  type="button"
                  onClick={handleDepoisAgendar}
                  className="btn-secondary"
                  style={{ flex: 1 }}
                >
                  Depois
                </button>
                <button 
                  type="button"
                  onClick={handleAgendarAposGerar}
                  className="btn-primary"
                  style={{ 
                    flex: 1,
                    backgroundColor: '#10b981',
                    fontWeight: '600'
                  }}
                >
                  ✅ Sim, agendar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default KanbanCard;